<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
  <button type="button" class="btn-close" aria-label="Cerrar" (click)="onClose()"></button>
</div>

<div class="modal-body  politicas-confirm-delete-body">
  {{ message }}
</div>

<div
  class="modal-footer politicas-confirm-delete-footer d-flex flex-wrap gap-2 justify-content-end align-items-center"
>
  <app-cbb-button
    label="Cancelar"
    color="outline"
    (action)="onClose()"
    [disabled]="loading"
  ></app-cbb-button>
  <app-cbb-button
    [label]="confirmButtonLabel"
    [color]="confirmColor"
    (action)="onConfirm()"
    [disabled]="loading"
  ></app-cbb-button>
</div>
